import { captureException } from '@sentry/react';
import { useFirebase } from 'containers/FirebaseContext';
import { collection, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { filter, get } from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useCurrentClass } from 'store/classes/selectors';
import { useNotifications } from 'store/notification/selectors';
import { useCurrentUser } from 'store/users/selectors';
import { useCollectionNotification } from 'utils/methods/firebaseNotification';

const useNotification = () => {
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();
  const { updateCollectionNotification } = useCollectionNotification();
  const currentClass = useCurrentClass();
  const { firestore, firebaseUser } = useFirebase();
  const allNotifications = useNotifications();
  const [notificationData, setNotificationsData] = useState([]);

  const filterByClass =
    get(currentUser, 'role', '') == 'teacher'
      ? filter(
          allNotifications,
          (obj) =>
            obj.classId == get(currentClass, 'id', '') && obj.userId !== get(currentUser, 'id'),
        )
      : filter(
          allNotifications,
          (obj) =>
            (obj.createdBy == get(currentClass, 'id', '') ||
              obj.createdBy == get(currentUser, 'id', '')) &&
            obj.userId !== get(currentUser, 'id') &&
            obj?.classId === get(currentClass, 'id', ''),
        );
  const sortedData = filterByClass.slice().sort((a, b) => {
    const dateA = new Date(a.modified);
    const dateB = new Date(b.modified);
    return dateB - dateA; // Compare in reverse order for new to past
  });

  const createNotification = async (data) => {
    updateCollectionNotification(data?.id, get(currentUser, 'id', ''));
  };

  useEffect(() => {
    if (!firebaseUser) return;
    const unsubscribe = listenToNotificationData(get(currentClass, 'id', ''), currentUser.id);
    return () => {
      if (unsubscribe && typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, [currentClass, currentUser, firebaseUser]);

  const listenToNotificationData = (classID, userId) => {
    if (!classID) {
      return () => {};
    }
    const collectionRef = collection(firestore, 'notifications');
    const q = query(
      collectionRef,
      where('classId', '==', classID),
      where('receiversId', 'array-contains', userId),
      where('senderId', '!=', currentUser.id),
      orderBy('modified', 'desc'),
    );
    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        const notifications = [];
        querySnapshot.forEach((doc) => {
          notifications.push({ id: doc.id, ...doc.data() });
        });
        setNotificationsData([...notifications, ...sortedData]);
      },
      (error) => {
        console.error('Error listening to session changes:', error);
      },
    );
    return unsubscribe;
  };

  const readSingleNotification = (chapter, page, user,assignment_data) => {
    try {
      if (!chapter || !page || !user) return;
      if (user?.role !== 'student') return;


      const data = notificationData.find(
        (x) =>
          x?.data?.chapter == chapter &&
          x?.data?.page == page &&
          x?.data?.id == assignment_data?.data?.id &&
          x?.receiversId?.includes(user?.id),
      );
  
      if (!data) {
        return;
      }
      const payloadData = {
        ...data,
        seen: false,
      };
      createNotification(payloadData, data);
    } catch (error) {
      captureException(error);
    }
  };

  return {
    readSingleNotification,
  };
};

export default useNotification;
